import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";

function AlreadyPaid() {
  return (
    <Container
      fluid
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "70vh" }}
    >
      <h1 className="text-center mb-4">Ove pripreme su već plaćene.</h1>
      <p className="text-center" style={{ fontSize: "1.2rem" }}>
        Vrati se na <Link to="/dashboard">dashboard</Link>.
      </p>
    </Container>
  );
}

export default AlreadyPaid;
